import { Option } from "@/components/select/AsyncAutocompleteSelect";
import { GetCheckRequestsProps } from "@/services/check-requests.service";
import dayjs, { Dayjs } from "dayjs";
import { formatCurrencyInputToNumber } from "@/utils/query-string";

export interface CRFRProps {
  request_date?: Dayjs;
  sucursal: number[];
  request_amount: string;
  requester: string;
  request_type: string[];
  account_number?: Option
  estados?: number[];
}

export const getCheckRequestFilter = (
  event: CRFRProps,
): Partial<GetCheckRequestsProps> => {
  let amount: string | undefined;

  if (event?.request_amount) {
    const num = formatCurrencyInputToNumber(event.request_amount);

    if (!Number.isNaN(num)) {
      amount = num.toFixed(2);
    }
  }

  return {
    ...(event?.estados?.length
      ? {
          estados: event?.estados,
        }
      : {}),
    ...(event?.request_date && dayjs(event?.request_date).isValid()
      ? {
          fechaDesde: dayjs(event?.request_date).toISOString(),
        }
      : {}),
   
    ...(event?.account_number
      ? {
          NroCuenta: event?.account_number?.value,
        }
      : {}),
    ...(event?.request_type?.length
      ? {
          TipoSolicitud: event?.request_type?.[0],
        }
      : {}),
    ...(event?.sucursal?.length
      ? {
          ClaveSucursal: event?.sucursal?.map(String),
        }
      : {}),
    ...(event?.request_amount && amount
      ? {
          monto: amount,
        }
      : {}),
    ...(event?.requester
      ? {
          Solicitante: event?.requester,
        }
      : {}),
  };
};
